import React, {Component, Fragment} from 'react';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Slide from "@material-ui/core/Slide/index";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {EnteroSolo, FieldsJs} from "../../../../settings/General/General";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import TextField from "@material-ui/core/TextField";
import {TimbradoFacturacionExtService} from "../../../../services/TimbradoFacturacionExtService/TimbradoFacturacionExtService";
import {DialogActions} from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import {AddOutlined, DeleteOutlined, Send} from "@material-ui/icons";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import {EmpresaFacturacionExtService} from "../../../../services/EmpresaFacturacionExtService/EmpresaFacturacionExtService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CONFIG} from "../../../../settings/Config/Config";
import ModalDescargaTimbrado from "../../Timbrado/Includes/ModalDescargaTimbrado";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";



class ModalPago extends Component {
	
	state = {};
	
	constructor(props) {
		super(props);
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			open_modal_xml: false,
			
			id_facturacion_cfdi: props.item.id_facturacion_cfdi || '',
			enviar_a: '',
			enviar_cc: '',
			enviar_cco: '',
			folio: '',
			fecha_pago: null,
			fecha: null,
			id_cat_forma_pago: '',
			monto: '',
			rfc_emisor_cuenta_ord: '',
			banco: '',
			rfc_emisor_cuenta_ben: '',
			cuenta_beneficiario: '',
			numero_parcialidad: '',
			importe_saldo_anterior: '',
			importe_pagado: '',
			importe_saldo_insoluto: '',
			id_cat_objeto_impuesto: '',
			folios_fiscales: false,
			
			listar_cat_objeto_impuesto: [],
			listar_cat_forma_pago: [],
			
			id_empresa_sucursal_serie: '',
			listar_empresa_sucursal_serie: [],
			
			folios_relacionados: [],
			id_cat_tipo_relacion: '',
			tipo_relacion: '',
			listar_folios: [],
			folios: []
			
		};
	}
	
	ListaFormaPago = () => {
		CatService.ListFormaPagoFac({}, {}).then((response) => {
			this.setState({
				listar_cat_forma_pago: response.data,
			});
		}).catch((error) => {
			this.setState({
				listar_cat_forma_pago: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	
	ListaObjetoImpuesto = () => {
		CatService.ListObjetoImpuestoFac({}, {}).then((response) => {
			this.setState({
				listar_cat_objeto_impuesto: response.data,
			});
		}).catch((error) => {
			this.setState({
				listar_cat_objeto_impuesto: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	handleChangeSerie = (id_empresa_sucursal_serie, valor) => {
		let series = FieldsJs.Copy(this.state.listar_empresa_sucursal_serie);
		for (let i = 0; i < series.length; i++) {
			if (Number(id_empresa_sucursal_serie) === Number(series[i].id_empresa_sucursal_serie)) {
				this.setState({
					serie: series[i].serie
				});
			}
		}
		
		EmpresaFacturacionExtService.SerieFolio(id_empresa_sucursal_serie).then((response) => {
			this.setState({
				folio: response.data
			});
		}).catch((error) => {
			this.setState({listar_facturacion: []});
			this.showSnackBars('error', error.mensaje);
		});
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			},
		});
		console.log(this.state, props);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	
	add = () => {
		let {item} = this.props;
		
		this.setState({
			id_facturacion_cfdi: item.id_facturacion_cfdi || '',
			enviar_a: (item.cliente || '').correo_electronico,
			enviar_cc: (item.cliente || '').correo_electronico_copia,
			enviar_cco: '',
			fecha_pago: null,
			fecha: null,
			id_cat_forma_pago: '',
			monto: '',
			rfc_emisor_cuenta_ord: '',
			banco: '',
			folio: '',
			rfc_emisor_cuenta_ben: '',
			cuenta_beneficiario: '',
			numero_parcialidad: '',
			importe_saldo_anterior: '',
			importe_pagado: '',
			id_cat_objeto_impuesto: '',
			importe_saldo_insoluto: '',
			uuid_relacionado: '',
			folios_fiscales: false,
			folios_relacionados: [],
			id_cat_tipo_relacion: '',
			tipo_relacion: '',
			listar_folios: [],
			folios: []
		});
		
		this.ListaFormaPago();
		this.ListaObjetoImpuesto();
		this.ListarTipoRelacion();
		this.ListaEmpresaSucursalSerie(item.id_empresa_sucursal);
		
		
		this.open();
		
	};
	
	pagoSat = () => {
		TimbradoFacturacionExtService.PagoCFDI(this.state).then((response) => {
			let msg = `${response.data.code} - ${response.data.message}`;
			PopupService.Confirm(['Aceptar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
				if (r.button === 'Aceptar') {
					this.setState({
						ruta: response.ruta,
						open_modal_xml: true
					});
				}
			});
			/*console.log(response);
			this.props.showSnackBars('success', response.mensaje);
			this.closeModal();
			this.props.RefreshList();*/
		}).catch((error) => {
			
			
			this.props.showSnackBars('error', error.mensaje);
			
		});
	}
	
	obtenerSaldoInsoluto = () => {
		let imp_ant = FieldsJs.Field(this.state.importe_saldo_anterior) ? Number(this.state.importe_saldo_anterior) : 0;
		let imp_pag = FieldsJs.Field(this.state.importe_pagado) ? Number(this.state.importe_pagado) : 0;
		
		this.setState({
			importe_saldo_insoluto: (imp_ant - imp_pag)
		});
	}
	
	ListaEmpresaSucursalSerie = (id_empresa_sucursal) => {
		EmpresaFacturacionExtService.Series(id_empresa_sucursal, {}).then((response) => {
			if (response.data.length > 0) {
				this.setState({
					listar_empresa_sucursal_serie: response.data,
					id_empresa_sucursal_serie: response.data[0].id_empresa_sucursal_serie,
					serie: response.data[0].serie,
				});
				this.handleChangeSerie(response.data[0].id_empresa_sucursal_serie);
			} else {
				this.setState({
					listar_empresa_sucursal_serie: response.data,
					id_empresa_sucursal_serie: '',
				});
			}
		}).catch((error) => {
			this.setState({
				listar_cat_moneda: []
			});
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	handleChangeFolios = (id_cliente, valor) => {
		this.setState({
			folios: valor,
		});
	}
	
	listar_foliosAgregarRelacionados = () => {
		
		try {
			
			if (!this.state.id_cat_tipo_relacion) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Tipo Relación.'
				})
			}
			
			if (this.state.folios.length <= 0) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Folio(s) Relacionado(s).'
				})
			}
		
			let impuestos = FieldsJs.Copy(this.state.folios_relacionados);
			
			let cat_impuesto_t = FieldsJs.Copy(this.state.listar_tipo_relacion);
			
			let it = '';
			let de = '';
			
			for (let i = 0; i < cat_impuesto_t.length; i++) {
				if (Number(this.state.id_cat_tipo_relacion) === Number(cat_impuesto_t[i].id_cat_tipo_relacion)) {
					it = cat_impuesto_t[i].tipo_relacion;
					de = cat_impuesto_t[i].descripcion;
				}
			}
			
			let item = {
				id_cat_tipo_relacion: this.state.id_cat_tipo_relacion,
				tipo_relacion: it,
				descripcion: de,
				folios: this.state.folios,
			};
			
			impuestos.push(item);
			
			this.setState({
				folios_relacionados: impuestos,
				id_cat_tipo_relacion: '',
				tipo_relacion: '',
				listar_folios: [],
				folios: [],
			});
			
		} catch (e) {
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	deleteRelacionados = (value, key) => {
		try {
			PopupService.Confirm(['Cancelar', 'Aceptar'], 'warning', CONFIG.titulo_alert_confirm, '¿Deseas eliminar el folio relacionado?').then((r) => {
				if (r.button === 'Aceptar') {
					let folios_relacionados = FieldsJs.Copy(this.state.folios_relacionados);
					
					folios_relacionados.splice(key, 1);
					
					this.setState({
						folios_relacionados: folios_relacionados
					});
				}
			});
			
		} catch (error) {
			this.props.showSnackBars('error', error.mensaje);
		}
	};
	
	ListarTipoRelacion = () => {
		CatService.ListTipoRelacionFac(this.state).then((response) => {
			this.setState({
				listar_tipo_relacion: response.data,
			})
		});
	};
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'add':
				funcion = this.add;
				break;
			
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.component ? (
					<Fragment>
						<span onClick={() => this.add()} style={{cursor: 'pointer'}}>
							{this.props.component}
						</span>
					</Fragment>
				) : (
					<Fragment>
						<Fab variant="extended" size="small" color="primary" aria-label="Add"
						     className={'margin-10-L'} onClick={() => this.openModal('paper')}>
							<Send className={'margin-5-R px-14'}/>
							Enviar Correo Electrónico
						</Fab>
					</Fragment>
				)}
				
				<ModalDescargaTimbrado item={this.state} open={this.state.open_modal_xml} showSnackBars={this.showSnackBars} RefreshList={this.RefreshList}/>
				
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						Recibo Electrónico de Pago
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2} alignItems={"flex-end"} alignContent={"flex-end"}>
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<KeyboardDateTimePicker
									format="yyyy/MM/dd hh:mm a"
									fullWidth
									required
									clearable
									inputProps={{readOnly: true}}
									KeyboardButtonProps={{
										'aria-label': 'Fecha de Pago',
									}}
									label="Fecha de Pago"
									value={this.state.fecha_pago}
									onChange={(date) => {
										this.handleChange(null, null, null, date, 'fecha_pago');
									}}
									// minDate={moment(new Date())}
									clearLabel={'Limpiar'}
									okLabel={'Aceptar'}
									cancelLabel={'Cancelar'}
									onError={console.log}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									select
									fullWidth
									required
									margin="none"
									onChange={this.handleChange}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_cat_forma_pago"
									label="Forma de Pago"
									value={this.state.id_cat_forma_pago}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.listar_cat_forma_pago.map(option => (
										<option key={option.id_cat_forma_pago} value={option.id_cat_forma_pago}>
											{option.descripcion ? option.forma_pago + " - " + option.descripcion : option.forma_pago}
										</option>
									))}
								</TextField>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									required
									disabled
									margin="none"
									name="monto"
									label="Monto"
									type="text"
									fullWidth
									value={this.state.monto}
									onChange={(e) => {
										this.handleChange(e);
									}}
									onKeyPress={EnteroSolo}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									select
									fullWidth
									required
									margin="none"
									onChange={this.handleChange}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_cat_objeto_impuesto"
									label="Objeto de Impuesto"
									value={this.state.id_cat_objeto_impuesto}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.listar_cat_objeto_impuesto.map(option => (
										<option key={option.id_cat_objeto_impuesto} value={option.id_cat_objeto_impuesto}>
											{option.descripcion ? option.objeto_impuesto + ' - ' + option.descripcion : option.objeto_impuesto}
										</option>
									))}
								</TextField>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									name="rfc_emisor_cuenta_ord"
									label="RFC Emisor Cuenta Ord: "
									type="text"
									fullWidth
									value={this.state.rfc_emisor_cuenta_ord}
									onChange={this.handleChange}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									name="banco"
									label="Banco"
									type="text"
									fullWidth
									value={this.state.banco}
									onChange={this.handleChange}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									name="rfc_emisor_cuenta_ben"
									label="RFC Emisor Cuenta Beneficiario: "
									type="text"
									fullWidth
									value={this.state.rfc_emisor_cuenta_ben}
									onChange={this.handleChange}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									name="cuenta_beneficiario"
									label="Cuenta Beneficiario"
									type="text"
									fullWidth
									value={this.state.cuenta_beneficiario}
									onChange={this.handleChange}
									onKeyPress={EnteroSolo}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									required
									name="numero_parcialidad"
									label="Número de parcialidad"
									type="text"
									fullWidth
									value={this.state.numero_parcialidad}
									onChange={this.handleChange}
									onKeyPress={EnteroSolo}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									required
									name="importe_saldo_anterior"
									label="Importe Saldo Anterior"
									type="text"
									fullWidth
									value={this.state.importe_saldo_anterior}
									onChange={(e) => {
										this.handleChange(e);
										setTimeout(() => {
											this.obtenerSaldoInsoluto(e);
										}, 800);
									}}
									onKeyPress={EnteroSolo}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									required
									name="importe_pagado"
									label="Importe Pagado"
									type="text"
									fullWidth
									value={this.state.importe_pagado}
									onChange={(e) => {
										this.handleChange(e);
										this.setState({
											monto: e.target.value
										});
										setTimeout(() => {
											this.obtenerSaldoInsoluto(e);
										}, 800);
									}}
									onKeyPress={EnteroSolo}
								/>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={6} lg={6} xl={6}>
								<TextField
									required
									name="importe_saldo_insoluto"
									label="Importe Saldo Insoluto"
									type="text"
									fullWidth
									value={this.state.importe_saldo_insoluto}
									onChange={this.handleChange}
									onKeyPress={EnteroSolo}
								/>
							</Grid>
							
							<Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
								<TextField
									required
									select
									fullWidth
									margin="none"
									onChange={(e) => {
										this.handleChange(e);
										this.handleChangeSerie(e.target.value);
									}}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_empresa_sucursal_serie"
									label="Serie"
									value={this.state.id_empresa_sucursal_serie}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.listar_empresa_sucursal_serie.map(option => (
										<option key={option.id_empresa_sucursal_serie} value={option.id_empresa_sucursal_serie}>
											{option.serie}
										</option>
									))}
								</TextField>
							</Grid>
							
							<Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
								<TextField
									required
									margin="none"
									name="folio"
									label="Folio"
									type="text"
									fullWidth
									value={this.state.folio}
									onChange={this.handleChange}
									disabled
								/>
							</Grid>
							
							<Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
								<TextField
									select
									fullWidth
									margin="none"
									onChange={(e) => {
										this.handleChange(e);
									}}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="fecha"
									label="Fecha de CFDI"
									value={this.state.fecha}
								>
									<option value={'1'}>Timbrar con fecha actual</option>
									<option value={'2'}>Fecha de ayer</option>
									<option value={'3'}>Fecha de hace dos días</option>
									<option value={'4'}>Fecha de hace tres días</option>
								</TextField>
							</Grid>
							
							{/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<FormGroup row>
									<FormControlLabel
										control={
											<Checkbox
												type="checkbox"
												name='folios_fiscales'
												checked={this.state.folios_fiscales}
												onChange={(e) => {
													this.handleChange(e);
												}}
												value="folios_fiscales"
												color="primary"
												disabled={this.props.tipo === 'view'}
											/>
										}
										label={'Folios Fiscales Relacionados'}
									/>
								</FormGroup>
							</Grid>
							
							{this.state.folios_fiscales ? (
								<Fragment>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<TextField
											select
											fullWidth
											required
											margin="none"
											onChange={this.handleChange}
											SelectProps={{
												native: true,
												MenuProps: {
													className: '',
												},
											}}
											name="id_cat_tipo_relacion"
											label="Tipo Relación"
											value={this.state.id_cat_tipo_relacion}
										>
											<option key={0} value={''}>&nbsp;</option>
											{this.state.listar_tipo_relacion.map(option => (
												<option key={option.id_cat_tipo_relacion}
												        value={option.id_cat_tipo_relacion}>
													{option.tipo_relacion ? option.tipo_relacion + ' - ' + option.descripcion : option.descripcion}
												</option>
											))}
										</TextField>
									</Grid>
									
									<Grid item xs={12} sm={10} md={10} lg={10} xl={10}>
										<Autocomplete
											multiple
											id="autocomplete_folios"
											options={this.state.listar_folios}
											getOptionLabel={(option) => option}
											//defaultValue={[this.state.listar_folios[13].title]}
											//value={this.state.listar_folios}
											freeSolo
											clearText
											renderTags={(value, getTagProps) =>
												value.map((option, index) => (
													<Chip variant="outlined" label={option} {...getTagProps({index})} />
												))
											}
											renderInput={(params) => (
												<TextField {...params} variant="outlined" label="" placeholder="Folio Fiscal" margin="none"/>
											)}
											onChange={(e, value) => {
												this.handleChangeFolios(e, value);
											}}
										/>
									</Grid>
									
									<Grid item xs={12} sm={6} md={2} lg={1} xl={1} align={'right'}>
										<div className={'w-auto vertical-inline h-100'}>
											<div className={'v-center'}>
												<Tooltip
													TransitionComponent={Zoom}
													placement={"top"}
													title={"Agregar"}
													children={(
														<Fab size="small" color="secondary"
														     aria-label={"Agregar"}
														     onClick={this.listar_foliosAgregarRelacionados}
														     style={{marginLeft: "15px"}}>
															<AddOutlined/>
														</Fab>
													)}
												/>
											</div>
										</div>
									</Grid>
									
									{this.state.folios_relacionados.length > 0 ? (
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
											<table className={'desing-mark'}>
												<thead>
												<tr>
													<th align={"center"}>Tipo Relación</th>
													<th align={"center"}>Folios</th>
													<th align={"right"}>Acciones</th>
												</tr>
												</thead>
												<tbody>
												{this.state.folios_relacionados.map((item, index) => (
														<tr key={index}>
															<td align={"center"}>{item.tipo_relacion + ' - ' + item.descripcion}</td>
															<td align={"center"}>
																{item.folios.map((item2, index2) => (
																	<p className={'margin-0'} key={index2}>{item2}</p>
																))
																}
															</td>
															<td align={'right'}>
																<Tooltip
																	TransitionComponent={Zoom}
																	placement={"top"}
																	title="Eliminar"
																	children={(
																		<Fab
																			size="small"
																			aria-label="Eliminar"
																			onClick={() => this.deleteRelacionados(item, index)}
																			style={{
																				marginLeft: "10px",
																				backgroundColor: "transparent",
																				color: "#808080",
																				boxShadow: "none",
																			}}
																			children={(
																				<DeleteOutlined/>
																			)}
																		/>
																	)}
																/>
															</td>
														</tr>
													)
												)}
												</tbody>
											</table>
										</Grid>
									) : null}
								
								</Fragment>
							) : null}*/}
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={'margin-15-T'}>
								
								<fieldset className={'borde-punteado-gray-2 text-left'}>
									<legend align={'left'} style={{color: 'dimgrey', fontWeight: 'bold'}}> Datos de envío</legend>
									
									<Grid container spacing={2}>
										
										<Grid item className={'text-left'} xs={12} sm={12} md={12} lg={12} xl={12}>
											<TextField
												required
												name="enviar_a"
												label="Enviar a: "
												type="text"
												fullWidth
												value={this.state.enviar_a}
												onChange={this.handleChange}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
											<TextField
												name="enviar_cc"
												label="Cc:"
												type="text"
												fullWidth
												value={this.state.enviar_cc}
												onChange={this.handleChange}
											/>
										
										</Grid>
										
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
											<TextField
												name="enviar_cco"
												label="Cco:"
												type="text"
												fullWidth
												value={this.state.enviar_cco}
												onChange={this.handleChange}
											/>
										
										</Grid>
									
									</Grid>
								
								</fieldset>
							
							</Grid>
							{/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12} align={'center'}>
								<Divider style={{marginTop: "10px", marginBottom: "15px"}}/>
								<div className={'text-right'}>
									<div className={'vertical-inline'}>
										<Button className={'v-center margin-15-R'} color="default" size={'small'} variant="contained" onClick={() => this.handleChangeTabs(null, '2')}>
											{'Cerrar'}
										</Button>
										<Button className={'v-center'} color="primary" size={'small'} variant="contained" onClick={() => this.pagoSat()}>
											{'Generar Pago'}
										</Button>
									</div>
								</div>
							</Grid>*/}
						</Grid>
					
					</DialogContent>
					
					<DialogActions>
						<Grid container spacing={2}>
							<Grid item xs={6} align={'left'}>
								<Button onClick={() => this.close()} color="primary">
									Cerrar
								</Button>
							</Grid>
							<Grid item xs={6} align={'right'}>
								<Button onClick={() => this.pagoSat()} color="primary" variant={"contained"}>
									Generar Pago
								</Button>
							</Grid>
						</Grid>
					</DialogActions>
				
				</Dialog>
			
			
			</div>
		);
	}
}

ModalPago.propTypes = {
	tipo: PropTypes.oneOfType([
		PropTypes.string.isRequired,
		PropTypes.oneOf(['view', 'add', 'edit']).isRequired,
	]),
	item: PropTypes.object,
	componente: PropTypes.element,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalPago;
